import { render, staticRenderFns } from "./uploadDetail.vue?vue&type=template&id=18d2d686&scoped=true&"
import script from "./uploadDetail.vue?vue&type=script&lang=js&"
export * from "./uploadDetail.vue?vue&type=script&lang=js&"
import style0 from "./uploadDetail.vue?vue&type=style&index=0&id=18d2d686&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d2d686",
  null
  
)

export default component.exports